import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { GrupoItens, ItemSelecao } from './item-selecao';

@Component({
  selector: 'app-paineis-selecao-checkboxes',
  templateUrl: './paineis-selecao-checkboxes.component.html',
  styleUrl: './paineis-selecao-checkboxes.component.scss',
  standalone: false,
})
export class PaineisSelecaoCheckboxesComponent {

  @Input() itensEsquerda: ItemSelecao[] = [];
  @Input() set itensDireita(valor: ItemSelecao[]) {
    this._itensDireita = valor;
    this.atualizarItensDireitaFiltrados();
  }
  @Input() tituloEsquerda: string = '';
  @Input() labelColunaEsquerda: string = 'Nome';
  @Input() tituloSemSelecao: string = '';
  @Input() tituloDireita: string = '';
  @Input() mensagemSemSelecao: string = '';
  @Input() labelAcaoExtra?: string;
  @Input() salvando: boolean = false;
  @Input() salvarDesabilitado: boolean = false;

  @Output() itemSelecionado = new EventEmitter<ItemSelecao>();
  @Output() salvarClick = new EventEmitter<{ esquerdaId: number }>();
  @Output() toggleItem = new EventEmitter<{ item: ItemSelecao; checked: boolean }>();
  @Output() acaoExtraClick = new EventEmitter<void>();

  @ViewChild('dt') table!: Table;

  itemAtual: ItemSelecao | null = null;
  itensDireitaFiltrados: ItemSelecao[] = [];
  agrupado: boolean = false;
  gruposDireita: GrupoItens[] = [];
  gruposExpandidos: Record<string, boolean> = {};

  private _itensDireita: ItemSelecao[] = [];
  private termoBusca: string = '';

  public selecionar(item: ItemSelecao | ItemSelecao[] | undefined): void {
    if (!item || Array.isArray(item)) return;
    this.itemAtual = item;
    this.itemSelecionado.emit(item);
  }

  public salvar(): void {
    if (!this.itemAtual) return;
    this.salvarClick.emit({ esquerdaId: this.itemAtual.id });
  }

  // O estado visual considera todos os itens do grupo (inclusive os bloqueados, que continuam
  // marcados/desmarcados na tela); só o clique ignora os bloqueados.
  public isGrupoSelecionado(grupo: GrupoItens): boolean {
    return grupo.itens.length > 0 && grupo.itens.every(i => i.checado);
  }

  public isGrupoIndeterminate(grupo: GrupoItens): boolean {
    return grupo.itens.some(i => i.checado) && !grupo.itens.every(i => i.checado);
  }

  public isGrupoDisabled(grupo: GrupoItens): boolean {
    return this.itensHabilitados(grupo).length === 0;
  }

  public toggleGrupo(grupo: GrupoItens): void {
    const habilitados = this.itensHabilitados(grupo);
    const marcar = !habilitados.every(i => i.checado);
    habilitados.forEach(item => this.toggleItem.emit({ item, checked: marcar }));
  }

  public filtrar(valor: string): void {
    this.termoBusca = valor;
    this.atualizarItensDireitaFiltrados();
    this.table.filterGlobal(valor, 'contains');
  }

  private atualizarItensDireitaFiltrados(): void {
    const termo = this.termoBusca.trim().toLowerCase();
    this.itensDireitaFiltrados = !termo
      ? this._itensDireita
      : this._itensDireita.filter(i =>
        i.label.toLowerCase().includes(termo) || (i.sublabel ?? '').toLowerCase().includes(termo));

    this.atualizarGruposDireita(!!termo);
  }

  private itensHabilitados(grupo: GrupoItens): ItemSelecao[] {
    return grupo.itens.filter(i => !i.bloqueado);
  }

  // Agrupa quando os itens trazem `grupo` (ex: permissões por módulo, onde todo item tem grupo);
  // sem grupo (ex: papéis do usuário), a lista fica plana.
  private atualizarGruposDireita(expandirTodos: boolean): void {
    this.agrupado = this._itensDireita.some(i => !!i.grupo);
    if (!this.agrupado) {
      this.gruposDireita = [];
      return;
    }

    const grupos = new Map<string, ItemSelecao[]>();
    for (const item of this.itensDireitaFiltrados) {
      grupos.set(item.grupo!, [...(grupos.get(item.grupo!) ?? []), item]);
    }
    this.gruposDireita = [...grupos].map(([grupo, itens]) => ({ grupo, itens }));

    // Grupos novos começam expandidos; ao buscar, expande todos para os resultados ficarem visíveis.
    const expandidos: Record<string, boolean> = { ...this.gruposExpandidos };
    for (const { grupo } of this.gruposDireita) {
      if (expandirTodos || !(grupo in expandidos)) expandidos[grupo] = true;
    }
    this.gruposExpandidos = expandidos;
  }
}
